export default __webpack_public_path__ + "static/media/signin-circle-yellow.f782d978.svg";